export default __webpack_public_path__ + "locales/sr-Latn-RS/Errors.json?hash=a120101f0d0f5d13d567a0690120b12e";